import { IDevice } from "@formant/core/model/IDevice";
import { IRosTopic } from "@formant/core/model/IRosTopic";

import { hiddenRosTopics } from "../../configuration/hiddenRosTopics";

export function rosTopicsForDevices(
    devices: IDevice[] | undefined,
): IRosTopic[] {
    if (!devices) {
        return [];
    }

    const isNotHiddenTopic = (topic: IRosTopic) =>
        !hiddenRosTopics.has(topic.name);

    const rosTopics: IRosTopic[] = [];
    const seenTopicNames = new Set<string>();
    for (const device of devices) {
        const topics = device?.state?.ros?.topics || [];
        for (const topic of topics) {
            if (isNotHiddenTopic(topic) && !seenTopicNames.has(topic.name)) {
                rosTopics.push(topic);
                seenTopicNames.add(topic.name);
            }
        }
    }
    return rosTopics.sort((a, b) => a.name.localeCompare(b.name));
}
